import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_BANNER_SUCCESS,
  GET_ALL_BANNER_REQUEST,
  GET_ALL_BANNER_FAILURE,
} from "./ActionType";

export const getAllDesignerDiscountBanners = () => async (dispatch) => {
  dispatch({ type: GET_ALL_BANNER_REQUEST });
  try {
    const { data } = await publicAxios.get(`designerDiscountBanners`);
    dispatch({ type: GET_ALL_BANNER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_BANNER_FAILURE, payload: error.message });
  }
};

